import { IconComponentsProps } from './types';

const CalendarIcon = ({ fill = '#1010EB', ...props }: IconComponentsProps) => (
  <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M16.5 1.5H13.5V0H12V1.5H6V0H4.5V1.5H1.5C0.675 1.5 0 2.175 0 3V18C0 18.825 0.675 19.5 1.5 19.5H16.5C17.325 19.5 18 18.825 18 18V3C18 2.175 17.325 1.5 16.5 1.5ZM16.5 18H1.5V7.5H16.5V18ZM16.5 6H1.5V3H4.5V4.5H6V3H12V4.5H13.5V3H16.5V6Z"
      fill={fill}
    />
  </svg>
);

export default CalendarIcon;
